import type { LucideIcon } from 'lucide-react';

interface EmptyStateProps {
  Icon: LucideIcon;
  heading: string;
  body: string;
}

export function EmptyState({ Icon, heading, body }: EmptyStateProps): JSX.Element {
  return (
    <div className="flex flex-col items-center gap-3 px-6 py-12 text-center">
      <span className="flex size-14 items-center justify-center rounded-full bg-zinc-100 text-zinc-500">
        <Icon aria-hidden="true" className="size-7" />
      </span>
      <h2 className="text-xl font-semibold leading-tight text-zinc-900">{heading}</h2>
      <p className="max-w-[40ch] text-base leading-normal text-zinc-600">{body}</p>
    </div>
  );
}
